import { Logger } from '../../../logger/Logger';
import { autoplayActions } from '../../../store/slices/autoplay/slice';
import { betActions } from '../../../store/slices/bets/slice';
import type { AcceptedBet } from '../../../store/slices/bets/types';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

type AcceptanceState = 'accepted' | 'not_accepted' | 'rejected';

export class CoreEnableSubmitGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.EnableSubmit;

  // enableSubmit signifies that the period that allows acceptance of late bets is closed
  public process(_message: GameCommunicationMessageType): void {
    const betState = this.store.getState().bets;

    if (betState.totalBet) {
      const checkResult = this.checkThatAllBetsAreProcessed(betState.acceptedBets);
      if (checkResult === 'not_accepted') {
        this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.NotAllBetsAccepted));
      } else if (checkResult === 'rejected') {
        this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.BetsRejected));
        this.store.dispatch(autoplayActions.stop());
        this.store.dispatch(betActions.resetBetStack());
        Logger.logEvent('autoplay_stop', {
          additional: 'BetsRejected',
        });
      }
    }
  }

  public checkThatAllBetsAreProcessed(acceptedBets: AcceptedBet[]): AcceptanceState {
    let checkResult: AcceptanceState = 'accepted';
    let rejectedBetsCount = 0;

    for (let i = 0; i < acceptedBets.length; i++) {
      const acceptedBet = acceptedBets[i];
      if (acceptedBet !== undefined && (acceptedBet.errorCode === -1 || acceptedBet.errorCode > 0)) {
        checkResult = 'not_accepted';
        rejectedBetsCount++;
      }
    }

    if (rejectedBetsCount === acceptedBets.length) {
      checkResult = 'rejected';
    }

    return checkResult;
  }
}
